import {
  asCurrency,
  asCurrencyWithCents,
  asQuantityWithUnit,
} from '../utils/formatters';

export const INPUT_METRICS = [
  {
    displayString: 'Input',
    accessor: 'name',
  },
  {
    displayString: 'Package size',
    accessor: 'packageSize',
  },
  {
    displayString: 'Package cost',
    accessor: 'packageCostWithShipping',
    format: asCurrencyWithCents,
  },
  {
    displayString: 'Units needed',
    accessor: 'unitQuantityByYear',
  },
  {
    displayString: 'Purchase quantity',
    accessor: 'purchaseQuantityByYear',
    format: asQuantityWithUnit('packages', 'package'),
  },
  {
    displayString: 'Total cost',
    accessor: 'totalCostByYear',
    format: asCurrency,
  },
];

export const INPUT_CROP_METRICS = [
  ...INPUT_METRICS,
  {
    displayString: 'Application rate',
    accessor: 'applicationRate',
  },
];
